import { createContext, useContext, useState, useEffect } from "react";
import { translations, languages } from "@/lib/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first, default to French
    if (typeof window !== "undefined") {
      return localStorage.getItem("lacrea-lang") || "fr";
    }
    return "fr";
  });

  useEffect(() => {
    localStorage.setItem("lacrea-lang", language);
    document.documentElement.lang = language;
  }, [language]);

  const t = translations[language];

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage: changeLanguage, t, languages }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
